import React from "react";

const ServiceCardTwo = ({ data }) => {
  const { url, iconName, title } = data;
  return (
    <a href={url}>
      <a className="icon_box_1 text-center">
        <div className="flipper">
          <div className="front">
            <i className={iconName}/>
            <h3>{title}</h3>
          </div>
          <div className="back">
            <i className={iconName}/>
            <h3>{title}</h3>
          </div>
        </div>
      </a>
    </a>
  );
};

export default ServiceCardTwo;
